// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addQuarters as fn } from "../addQuarters.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addQuarters = convertToFP(fn, 2);

// Fallback for modularized imports:
export default addQuarters;
